import { render, staticRenderFns } from "./voting.vue?vue&type=template&id=29b44d54&scoped=true"
import script from "./voting.vue?vue&type=script&lang=js"
export * from "./voting.vue?vue&type=script&lang=js"
import style0 from "./voting.vue?vue&type=style&index=0&id=29b44d54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b44d54",
  null
  
)

export default component.exports